<template>
	<div class="view-wrapper">
		<div class="card-columns" id="playfield">

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Character
				</template>
				<character-card></character-card>
			</b-card>

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Ability Scores
				</template>
				<ability-score-card></ability-score-card>
			</b-card>

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Saves &amp; Initiative
				</template>
				<saves-init-card></saves-init-card>
			</b-card>

			<b-card header-tag="h5" body-class="p-2">
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Dice
				</template>
				<dice-card></dice-card>
			</b-card>

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Combat
				</template>
				<combat-card></combat-card>
			</b-card>

			<b-card header-tag="h5" no-body v-if="isCaster">
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Spells
				</template>
				<spells-card></spells-card>
			</b-card>

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Skills
				</template>
				<skills-card></skills-card>
			</b-card>

			<b-card header-tag="h5" no-body>
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Abilities
				</template>
				<abilities-card></abilities-card>
			</b-card>

			<b-card header-tag="h5" no-body v-if="hasDrone">
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Drone
				</template>
				<drone-card></drone-card>
			</b-card>

			<b-card header-tag="h5" no-body v-if="hasCompanion">
				<template v-slot:header>
					<font-awesome-icon icon="grip-vertical"></font-awesome-icon>&nbsp;Companion
				</template>
				<companion-card></companion-card>
			</b-card>

		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

import CharacterCard from '@/components/play/CharacterCard.vue'
import AbilityScoreCard from '@/components/play/AbilityScoreCard.vue'
import SavesInitCard from '@/components/play/SavesInitCard.vue'
import DiceCard from '@/components/play/DiceCard.vue'
import CombatCard from '@/components/play/CombatCard.vue'
import SpellsCard from '@/components/play/SpellsCard.vue'
import SkillsCard from '@/components/play/SkillsCard.vue'
import AbilitiesCard from '@/components/play/AbilitiesCard.vue'
import DroneCard from '@/components/play/DroneCard.vue'
import CompanionCard from '@/components/play/CompanionCard.vue'

export default {
	name: 'PlayTab',
	components: {
		'CharacterCard': CharacterCard,
		'AbilityScoreCard': AbilityScoreCard,
		'SavesInitCard': SavesInitCard,
		'DiceCard': DiceCard,
		'CombatCard': CombatCard,
		'SpellsCard': SpellsCard,
		'SkillsCard': SkillsCard,
		'AbilitiesCard': AbilitiesCard,
		'DroneCard': DroneCard,
		'CompanionCard': CompanionCard,
	},
	computed: {
		...mapGetters('character/spells',[
			'isCaster',
		]),
		...mapGetters('character/drones',[
			'hasDrone',
		]),
		...mapGetters('character/companions',[
			'hasCompanion',
		]),
	}
}
</script>

<style scoped>
.card-header {
    padding-left: 10px;
}
</style>